import React, { ReactElement } from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import { Giveaway } from './views/giveaway/Giveaway';
import { ThirdPartySoftware } from './views/third-party-software/Third-Party-Software';
import { ApiClientProvider } from './services/ApiClientService';
import { fromDerivedStage } from './services/StageUtilService';
import { CupraApiClient } from './client/CupraApiClient';

const App = (): ReactElement => {
  const httpClient = new CupraApiClient(fromDerivedStage(new URL(window.location.href).hostname));

  return (
    <ApiClientProvider value={httpClient}>
      <Routes>
        <Route path="/:giveawayId" element={<Giveaway />} />
        <Route path="/third-party-software" element={<ThirdPartySoftware />} />
      </Routes>
    </ApiClientProvider>
  );
};

export default App;
